import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../img/logo.jpg';
import './responsiveHeader.scss';

const ResponsiveHeader = ({ fixed }) => {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const barsIcon = <FontAwesomeIcon icon={faBars}></FontAwesomeIcon>;
  return (
    <>
      <div className="main flex bg-transparent z-10 flex-wrap py-0">
        <div className="w-full">
          <nav className="relative flex flex-wrap items-center justify-between rounded">
            <div className="container mx-auto flex flex-wrap items-center justify-between">
              <div className="w-full relative flex justify-between lg:w-auto px-4 lg:static lg:block lg:justify-start">
                <Link
                  className="leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase"
                  to="/"
                >
                  <img height={40} width={40} src={Logo} alt="logo" />
                </Link>
                <button
                  className="primary-color cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
                  type="button"
                  onClick={() => setMenuOpen(!menuOpen)}
                >
                  {barsIcon}
                </button>
              </div>
              <div
                className={
                  'lg:flex flex-grow items-center' +
                  (menuOpen ? ' flex' : ' hidden')
                }
                id="example-navbar-info"
              >
                <ul className="flex flex-col w-full md:w-max md:flex-row list-none md:ml-auto font-semibold">
                  <li className="nav-item;">
                    <Link className="button" to="/">
                      Home
                    </Link>
                  </li>
                  <li className="nav-   item">
                    <Link className="button" to="/about-us">
                      About Us
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="button" to="/services">
                      Services
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="button" to="/doctors">
                      Doctor
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="button" to="/contact">
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};
export default ResponsiveHeader;
